module.exports = __webpack_public_path__ + "static/media/info_icon_ds.0ee0b145.svg";